import React, { Component } from 'react';
import { Modal } from 'antd';


import './SubmitModal.css';
class SubmitModal extends Component {
        // 初始状态
    state = {
        visible: false
    };

    showModal = () => {
        this.setState({
            visible: true,
        });
    }

    handleOk = (e) => {
        console.log(e);
        this.setState({
            visible: false,
        });
        console.log(this.props.submit())
    }

    handleCancel = (e) => {
        this.setState({
            visible: false,
        });
    }


    render() {
        const {} = this.props;
        return (
            <div>
                <Modal
                    title="submit"
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                >
                    <p>Whether to submit ?</p>
                </Modal>
            </div>
        );
    }
}

export default SubmitModal;
